import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M7.227 12l8.845-8.845a.75.75 0 0 0-1.06-1.06l-8.934 8.933a1.374 1.374 0 0 0 0 1.944l8.933 8.933a.75.75 0 0 0 1.061-1.06L7.227 12z' />
  </svg>
);
